import React from 'react';
import { I18n } from '@kineticdata/react';
import { CardCol, CardRow } from '@kineticdata/bundle-common';

export const ExternalOfferingCard = ({ offering, components = {} }) => {
  return (
    <a
      className="card"
      href={offering.values['URL']}
      target="_blank"
      rel="noopener noreferrer"
    >
      <CardRow className="py-4">
        <CardRow type="prepend" className="text-muted">
          <span
            className={`fa fa-2x fa-${(
              offering.values['Icon'] || 'external-link-square-alt'
            ).replace(/^fa-/i, '')} fa-fw`}
          />
        </CardRow>
        <CardCol>
          <CardRow type="subtitle">
            <span>
              <I18n>{offering.values['Name']}</I18n>
            </span>
          </CardRow>
          <CardRow className="text-muted">
            <span
              className="badge badge-subtle badge-sm align-self-center mr-1"
              title="External Offering"
            >
              <I18n>External</I18n>
            </span>
            <span>
              <I18n>{offering.values['Short Description']}</I18n>
            </span>
          </CardRow>
        </CardCol>
      </CardRow>
    </a>
  );
};
